import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextInput } from '../../../../core-components/theme/components/Fields';

import { CLOCK_LENGTH, CLOCK_PATTERN, settledClock, typedClock } from './clockEntry';

const clockSx = { fontVariantNumeric: 'tabular-nums' } as const;

export interface ClockInputProps {
  readonly label: string;
  readonly value: string;
  readonly error: boolean;
  readonly disabled: boolean;
  readonly readOnly: boolean;
  readonly describedById?: string;
  readonly helperText?: string;
  readonly inputRef?: React.Ref<HTMLInputElement>;
  readonly onValueChange: (value: string) => void;
  readonly onBlur?: () => void;
}

export const ClockInput: React.FC<ClockInputProps> = ({ value, error, onValueChange, onBlur, ...field }) => {
  const { t } = useTranslation();
  const settle = (): void => {
    const settled = settledClock(value);
    if (settled !== value) onValueChange(settled);
    onBlur?.();
  };
  return (
    <TextInput
      {...field}
      error={error}
      value={value}
      placeholder={t('closeTheLoop.quietHours.clockHint', 'HH:MM')}
      inputProps={{
        inputMode: 'numeric',
        pattern: CLOCK_PATTERN,
        maxLength: CLOCK_LENGTH,
        autoComplete: 'off',
        'aria-invalid': error ? true : undefined,
      }}
      inputSx={clockSx}
      onValueChange={(raw) => onValueChange(typedClock(raw))}
      onBlur={settle}
    />
  );
};
